import qt_util from '@libs/qt/util';
import qt_storage from '@libs/qt/storage';
import _config from '@js/config';

export default (function(context,factory){

	return factory();

})(window,function(){

	/**
	 * @desc 日志&错误上报模块
	 * @exports
	 * @version 1.0.0
	 * @author maixingjie
	 * @copyright Copyright 2017-2027
	 * 
	 */
	var qt_model = {};

	//获取用户信息
	qt_model.log = (...args) => {

		if(true){
			return
		}

		if(_config.isDev){
			console.log.apply(this,args);
		}
	}

	/**
	 * @desc 错误上报类型
	 */
	qt_model.ERROR_TYPE_HTTP = 'http';
	qt_model.ERROR_TYPE_BUSINESS = 'business';
	qt_model.ERROR_TYPE_ACTION = 'action';

	/**
	 * @desc 错误上报
	 * @param {Object} options 上报的数据
	 * @param {string} options.type 必填，错误类型
	 * @param {string} [options.userCode] 选填,用户唯一码
	 * @param {string} [options.classCode] 选填,班级码
	 * @param {string} [options.page] 选填,当前页面命名空间
	 * @param {string} [options.data] 选填,附加的具体数据
	 * @param {string} [options.data.httpCode] 选填,异常请求的http状态吗
	 * @param {string} [options.data.response] 选填,异常请求的http响应数据
	 * @param {string} [options.data.url] 选填,异常请求的url
	 * @param {string} [options.data.params] 选填,异常请求的参数（JSON.stringify的结果）
	 * @param {string} [options.data.resultCode] 选填,业务响应码
	 * @param {string} [options.data.resultMsg] 选填,业务响应消息
	 * @param {string} [options.data.msg] 选填,上报的自定义信息
	 */
	qt_model.errorStat = (options) => {

		let {type,userCode,classCode,page,data={}} = options;
		let {httpCode,response,resultCode,resultMsg,url,params,msg,...otherInfo} = data;

		type = 'bxe_error_'+(type?type:'notype');
		let currentPage = location.href;
		let info = {
			v: '1',
			version:_config.version,
			env:_config.isDev?'dev':'pro',
			type: type,
			timeStamp: qt_util.formatDate(qt_util.now(),'yyyy-MM-dd hh:mm:ss.S'),
			route: currentPage,
			userCode: userCode?userCode:qt_storage.sessionGet('userCode'),
			classCode: classCode?classCode:qt_storage.sessionGet('classCode'),
			page:page,
			data:{
				httpCode: httpCode,
				response: response,
				resultCode: resultCode,
				resultMsg: resultMsg,
				url:url,
				params:params,
				msg: msg, 
				otherInfo:info?JSON.stringify(otherinfo):''
			}
		}
		let _params = {
			tmpCode: 'bxe_error',
			infos: JSON.stringify(info)
		}

		let ping  = new Image();
		ping.src='https://bxr.eduwxt.com/collect/push?'+qt_util.param(_params);

	}
	
	return qt_model;
});













// WEBPACK FOOTER //
// ./src/js/log.js